import React from 'react'

// Inline SVG icons used internally by sutra components.
// No external asset files — these are brand/UI primitives.

export const Sparkle = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 18 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.21055 0.326953C7.11914 0.126563 6.91875 0 6.70078 0C6.48281 0 6.28242 0.126563 6.19102 0.326953L4.33477 4.33477L0.326953 6.1875C0.126563 6.27891 0 6.4793 0 6.70078C0 6.92227 0.126563 7.11914 0.326953 7.21055L4.33828 9.06328L6.1875 13.0711C6.27891 13.2715 6.4793 13.398 6.69727 13.398C6.91523 13.398 7.11563 13.2715 7.20703 13.0711L9.05977 9.05977L13.0711 7.20703C13.2715 7.11563 13.398 6.91523 13.398 6.69727C13.398 6.4793 13.2715 6.27891 13.0711 6.1875L9.06328 4.33828L7.21055 0.326953ZM13.5 11.25L11.5137 11.9953C11.3555 12.0551 11.25 12.2062 11.25 12.375C11.25 12.5438 11.3555 12.6949 11.5137 12.7547L13.5 13.5L14.2453 15.4863C14.3051 15.6445 14.4562 15.75 14.625 15.75C14.7938 15.75 14.9449 15.6445 15.0047 15.4863L15.75 13.5L17.7363 12.7547C17.8945 12.6949 18 12.5438 18 12.375C18 12.2062 17.8945 12.0551 17.7363 11.9953L15.75 11.25L15.0047 9.26367C14.9449 9.10547 14.7938 9 14.625 9C14.4562 9 14.3051 9.10547 14.2453 9.26367L13.5 11.25Z" />
  </svg>
)

export const ArrowRight = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

export const Plus = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    {...props}
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
)

export const Minus = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    {...props}
  >
    <path d="M5 12h14" />
  </svg>
)

export const ChevronDown = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
)

export const Check = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5 12l5 5L20 7" />
  </svg>
)

export const Close = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    {...props}
  >
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
)

export const Search = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    {...props}
  >
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
)

export const Flag = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 21V4" />
    <path d="M6 4h11l-3 4 3 4H6" />
  </svg>
)

export const Copy = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
  </svg>
)

export const Link = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 15l6-6" />
    <path d="M11 6l1-1a4 4 0 0 1 6 6l-1 1" />
    <path d="M13 18l-1 1a4 4 0 0 1-6-6l1-1" />
  </svg>
)
